import { defineMessages } from 'react-intl';

const messages = defineMessages({
  travelPlan: {
    id: 'repvisits.travel.plan.travelPlan',
    defaultMessage: 'Travel Plan',
  },
  travelPlanDescription: {
    id: 'repvisits.travel.plan.travelPlanDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'The Travel Plan lists high schools you plan to visit or will be visiting. You can add additional schools by selecting "Add to my travel plan" from the {recommendationsLink} section or when viewing Availability from a high school\'s profile.',
  },
  recommendations: {
    id: 'repvisits.travel.plan.recommendations',
    defaultMessage: 'Recommendations',
  },
  welcomeToTravelPlan: {
    id: 'repvisits.travel.plan.welcomeToTravelPlan',
    defaultMessage: 'Welcome to Travel Plan',
  },
  welcomeToTravelPlanImgAlt: {
    id: 'repvisits.travel.plan.welcomeToTravelPlanImgAlt',
    defaultMessage: 'Welcome to Travel Plan image',
  },
  welcomeToTravelPlanDescription: {
    id: 'repvisits.travel.plan.welcomeToTravelPlanDescription',
    // eslint-disable-next-line max-len
    defaultMessage: 'High Schools you plan to attend, and whom you have scheduled Visits and College Fairs with, will appear here. Add schools anytime by clicking "Add to my travel plan" from their profile',
  },
  type: {
    id: 'repvisits.travel.plan.type',
    defaultMessage: 'Type',
  },
  collegeGoingRate: {
    id: 'repvisits.travel.plan.collegeGoingRate',
    defaultMessage: 'College Going Rate',
  },
  seniorClassSize: {
    id: 'repvisits.travel.plan.seniorClassSize',
    defaultMessage: 'Senior Class Size',
  },
  primaryPOC: {
    id: 'repvisits.travel.plan.primaryPOC',
    defaultMessage: 'Primary POC',
  },
  institutionImgAlt: {
    id: 'repvisits.travel.plan.institutionImgAlt',
    defaultMessage: 'Institution image',
  },
  scheduled: {
    id: 'repvisits.travel.plan.scheduled',
    defaultMessage: 'Scheduled',
  },
  toDo: {
    id: 'repvisits.travel.plan.toDo',
    defaultMessage: 'To Do',
  },
  remove: {
    id: 'repvisits.travel.plan.remove',
    defaultMessage: 'Remove',
  },
  removeFromList: {
    id: 'repvisits.travel.plan.removeFromList',
    defaultMessage: 'Remove from list',
  },
  upcomingAppointment: {
    id: 'repvisits.travel.plan.upcomingAppointment',
    defaultMessage: 'Upcoming Appointment',
  },
  upcomingAppointments: {
    id: 'repvisits.travel.plan.upcomingAppointments',
    defaultMessage: 'Upcoming Appointments',
  },
  previousAppointments: {
    id: 'repvisits.travel.plan.previousAppointments',
    defaultMessage: 'Previous Appointments',
  },
  viewAvailability: {
    id: 'repvisits.travel.plan.viewAvailability',
    defaultMessage: 'View Availability',
  },
  pastAppointment: {
    id: 'repvisits.travel.plan.pastAppointment',
    defaultMessage: 'Past Appointment',
  },
  pastAppointments: {
    id: 'repvisits.travel.plan.pastAppointments',
    defaultMessage: 'Past Appointments',
  },
  collegeFair: {
    id: 'repvisits.travel.plan.collegeFair',
    defaultMessage: 'College Fair,',
  },
  pendingCollegeFair: {
    id: 'repvisits.travel.plan.pendingCollegeFair',
    defaultMessage: 'Pending College Fair,',
  },
  inPersonVisit: {
    id: 'repvisits.travel.plan.scheduleInPersonVisit',
    defaultMessage: 'In-Person Visit',
  },
  virtualVisit: {
    id: 'repvisits.travel.plan.scheduleVirtualVisit',
    defaultMessage: 'Virtual Visit',
  },
  visit: {
    id: 'repvisits.travel.plan.visit',
    defaultMessage: 'Visit,',
  },
  pendingVisit: {
    id: 'repvisits.travel.plan.pendingVisit',
    defaultMessage: 'Pending Visit,',
  },
  nothingScheduledYet: {
    id: 'repvisits.travel.plan.nothingScheduledYet',
    defaultMessage: 'Nothing scheduled yet',
  },
  upcomingFair: {
    id: 'repvisits.travel.plan.upcomingFair',
    defaultMessage: 'Upcoming Fair',
  },
  upcomingFairDetails: {
    id: 'repvisits.travel.plan.upcomingFairDetails',
    defaultMessage: 'This school has an upcoming College Fair on',
  },
  seeDetails: {
    id: 'repvisits.travel.plan.seeDetails',
    defaultMessage: 'See details »',
  },
  isntUsingRepVisits: {
    id: 'repvisits.travel.plan.isntUsingRepVisits',
    defaultMessage: 'This school is not using RepVisits yet',
  },
  removeError: {
    id: 'repvisits.travel.plan.removeError',
    defaultMessage: 'Unable to remove {name}',
  },
  removeHeader: {
    id: 'repvisits.travel.plan.removeHeader',
    defaultMessage: 'Remove from Travel Plan?',
  },
  removeHeaderOld: {
    id: 'repvisits.travel.plan.removeHeaderOld',
    defaultMessage: 'Remove from your travel plan',
  },
  removeDescription: {
    id: 'repvisits.travel.plan.removeDescription',
    defaultMessage: 'Are you sure you want to remove {institutionName} from your travel plan?',
  },
  successRemovedMessage: {
    id: 'repvisits.travel.plan.successRemovedMessage',
    defaultMessage: 'Successfully removed',
  },
  failureRemovedMessage: {
    id: 'repvisits.travel.plan.failureRemovedMessage',
    defaultMessage: 'Something unexpected happened. Please try your request again.',
  },
  buttonRemove: {
    id: 'repvisits.travel.plan.buttonRemove',
    defaultMessage: 'YES, REMOVE',
  },
  buttonCancel: {
    id: 'common.button.cancel',
    defaultMessage: 'CANCEL',
  },
});

export default messages;
